import { render } from "./GuardianSync.vue?vue&type=template&id=d8e8f0c4&scoped=true&ts=true"
import script from "./GuardianSync.vue?vue&type=script&lang=ts"
export * from "./GuardianSync.vue?vue&type=script&lang=ts"

import "./GuardianSync.vue?vue&type=style&index=0&id=d8e8f0c4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e8f0c4"]])

export default __exports__